module.exports = __webpack_public_path__ + "assets/img/Interiors-Australia-Landing-Page.5495589d.webp";